import { CurrentProvingContext } from 'context/CurrentProvingContext'
import * as React from 'react'

export function useCurrentProving() {
  return React.useContext(CurrentProvingContext)
}
